export default __webpack_public_path__ + "static/hero_circle-78a0927147a934df4310e6080e64f137.png";